require('./brokerInterveniersInterveniersTable.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

class BrokerInterveniersInterveniersTable extends React.Component {

    constructor(props) {
        super(props);
    }

    buildRows(brokerInterveners) {

        const data = brokerInterveners.get('list');

        
        return data.map((row, index) => {
            return (
                <OKTableRow key={index}>
                    <OKTableCell className="broker-interveniers-interveniers-table__table-name">
                        {row.get('nomInterviniente')}
                    </OKTableCell>
                    <OKTableCell className="broker-interveniers-interveniers-table__table-intervention-type">
                        {formatText(`interventionTypes-${row.get('tipoIntervencion').trim()}`)}
                    </OKTableCell>
                </OKTableRow>
            );
        });
    }

    buildTable(brokerInterveners) {
        const rows = this.buildRows(brokerInterveners);

        return (
            <OKTable className="broker-interveniers-interveniers-table__table">
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true} className="broker-interveniers-interveniers-table__table-name">
                            <FormattedText value="broker-interveniersName" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="broker-interveniers-interveniers-table__table-intervention-type">
                            <FormattedText value="broker-interveniersInterventionType" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </OKTable>
        );
    }

    render() {
        const { brokerInterveners } = this.props;
        const tableContent = this.buildTable(brokerInterveners);

        return (
            <ContentBox
                id="brokerInterveniersInterveniersTable"
                customClassName="broker-interveniers-interveniers-table"
            >
                <OKBoxTitle value={formatText('broker-interveniersInterveniers')} />
                {tableContent}
            </ContentBox>
        );
    }

}

BrokerInterveniersInterveniersTable.propTypes = {
    brokerInterveners: PropTypes.object
};

module.exports = BrokerInterveniersInterveniersTable;